<template>
	<div class="page-content__content page-content__content--noindent">
		<ScheduleCreate
			:type="'TN'"
			:deliveries="deliveries"
			:shopGroups="shopGroups"
			:distrCenter="distrCenters"
			:deliveryDestinations="deliveryDestinations"
			:productGroups="productGroups"
			/>
	</div>
</template>

<script>
import ScheduleCreate from "@/components/sections/Schedules/CreateEditSchedule/ScheduleCreate.vue";

export default {
	name: "CreateSchedule",
	components: { ScheduleCreate },
	props: {
		deliveries: {
			type: Array,
			default: () => []
		},
		shopGroups: {
			type: Array,
			default: () => []
		},
		distrCenters: {
			type: Array,
			default: () => []
		},
		deliveryDestinations: {
			type: Array,
			default: () => []
		},
		productGroups: {
			type: Array,
			default: () => []
		},
	},
}
</script>


